// export const BACKEND_URL = "http://localhost:5000";
export const BACKEND_URL = "https://app-shy-surf-996.fly.dev";
export const TIMEOUT = 30000;